<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['产品管理', '日化产品', title + '产品']" />
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form
                ref="form"
                class="add-form"
                :rules="rules"
                :model="form"
                label-width="140px"
            >
              <el-form-item label="驳回原因：" v-if="form.status === '3'">
                <p class="reject-text">{{form.reason + '，请确认修改完成后点击提交审核' }}</p>
              </el-form-item>
              <el-form-item label="关联品牌：" prop="brandId">
                <el-select filterable  v-model="form.brandId" placeholder="请选择" :disabled="title === '编辑'" style="width: 100%" @change="getOneList">
                  <el-option
                      v-for="item in brands"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="一级品类：" prop="oneList">
                <el-checkbox-group
                    v-model="form.oneList"
                    :max="3"
                >
                  <template v-for="(item, index) in selectCategoryList"  >
                    <el-checkbox disabled :label="item.id"  :key="index">{{item.name}}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="品类：" prop="category">
                  <div v-for="(item, index) in twoList" :key="index"><span style="color: blue">{{item.name}}：</span> <el-radio v-model="form.category" :key="inx" :label="i.id" v-for="(i, inx) in item.data">{{i.name}}</el-radio></div>
              </el-form-item>
              <el-form-item label="名称：" prop="name">
                <el-input v-model.trim="form.name" :disabled="title === '编辑'"></el-input>
              </el-form-item>
              <el-form-item label="零售价：" prop="price">
                <el-input v-model.trim="form.price" type="number" placeholder="请填入数字"></el-input>
              </el-form-item>
              <el-form-item label="宣传图：" prop="picture">
                <uploadXc @success="getPicture" :img="pictureList" :limit="20" />
              </el-form-item>
              <el-form-item label="视频：" prop="videoUrl">
                <videoUpload @success="getVideo" :list="videoList"  />
              </el-form-item>
              <el-form-item label="产品详情：" prop="detail">
                <editor ref="editor"   @setHtml="setHtml" />
              </el-form-item>
              <el-form-item label="寄样功能：" prop="sendSample">
                <el-radio-group v-model="form.sendSample">
                  <el-radio :label="item.id" v-for="item in sendSamples" :key="item.id">{{item.name}}</el-radio>
                </el-radio-group>
              </el-form-item>
<!--              <el-form-item label="是否备案：" prop="isRecord">-->
<!--                <el-radio-group v-model="form.isRecord" @change="changeRecord">-->
<!--                  <el-radio label="1">是</el-radio>-->
<!--                  <el-radio label="0">否</el-radio>-->
<!--                </el-radio-group>-->
<!--              </el-form-item>-->
              <el-form-item label="备案信息："  prop="record">
                <p style="color: #ee3d4a">请优先填写备案编号（含妆/特/消/械/药等），若未备案可填写其他执行标准编号。</p>
                <el-input v-model.trim="form.record" placeholder="请输入备案信息"></el-input>
              </el-form-item>
              <el-form-item label="是否是进口：" prop="wasForeign">
                <el-radio-group v-model="form.wasForeign" @change="form.address = ''">
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="form.wasForeign === '0'" label="生产地：" prop="address">
                <el-cascader
                    style="width: 100%"
                    v-model="form.address"
                    clearable
                    :options="originOptions"
                    :props="defaultProps"
                  ></el-cascader>
              </el-form-item>
              <el-form-item v-if="form.wasForeign === '1'" label="生产地：" prop="address">
                <el-select
                    filterable
                    style="width: 100%"
                      v-model="form.address"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in areaCodeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
              </el-form-item>
              <el-form-item label="今年新品：" prop="newProducts">
                <el-radio-group v-model="form.newProducts">
                  <el-radio label="0">否</el-radio>
                  <el-radio label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="生产企业：" prop="factory">
                <el-input v-model.trim="form.factory"></el-input>
              </el-form-item>
              <el-form-item label="规格：" prop="size">
                <el-input v-model.trim="form.size" placeholder="如20ml/瓶"></el-input>
              </el-form-item>
              <el-form-item label="排序：" prop="sort">
                <el-input-number v-model="form.sort" :min="0" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-form>
            <div class="info-footer">
              <el-button type="primary" @click="save">提交审核</el-button>
              <el-button @click="back">取消</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import navHeader from '../../components/navHeader.vue'
import uploadXc from '../../components/xcUpload.vue'
import editor from '../../components/editor.vue'
import videoUpload from '../../components/videoUpload'

export default {
  data () {
    return {
      timer: null,
      loading: true,
      id: '',
      title: '添加',
      form: {
        detail: '',
        wasForeign: '1',
        isRecord: '1',
        newProducts: '0',
        category: '',
        oneList: [],
        address: '',
        picture: '',
        sendSample: ''
      },
      pictureList: [],
      videoList: [],
      rules: {
        brandId: { required: true, message: '请选择关联品牌', trigger: 'blur' },
        name: {
          required: true,
          message: '请输入中文名',
          trigger: 'blur'
        },
        picture: {
          required: true,
          message: '请上传宣传图',
          trigger: 'blur'
        },
        one: {
          required: true,
          message: '请选择一级品类',
          trigger: 'blur'
        },
        category: {
          required: true,
          message: '请选择二级品类',
          trigger: 'blur'
        },
        origin: {
          required: true,
          message: '请选择原产地',
          trigger: 'blur'
        },
        // sendSample: {
        //   required: true,
        //   message: '请选择寄样功能',
        //   trigger: 'blur'
        // },
        isRecord: {
          required: true,
          message: '请选择是否备案',
          trigger: 'blur'
        },
        record: {
          required: true,
          message: '请输入备案信息',
          trigger: 'blur'
        },
        wasForeign: {
          required: true,
          message: '请选择是否是进口',
          trigger: 'blur'
        },
        address: {
          required: true,
          message: '请选择生产地',
          trigger: 'blur'
        }
      },
      sendSamples: [
        {
          name: '可以寄样',
          id: '1'
        },
        {
          name: '可以参观/看样',
          id: '2'
        },
        {
          name: '可供产品资料',
          id: '3'
        },
        {
          name: '以上都不支持',
          id: '4'
        }
      ],
      areaCodeList: [],
      originOptions: [],
      defaultProps: {
        children: 'children',
        label: 'name',
        value: 'id'
      },
      brands: [],
      selectCategoryList: [],
      brandCategoryList: [],
      twoList: []
    }
  },
  components: {
    navHeader,
    uploadXc,
    editor,
    videoUpload
  },
  created () {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
    } else {
      this.id = ''
    }
    if (this.$route.params.type) {
      this.type = this.$route.params.type
      this.title = '编辑'
    } else {
      this.type = 'add'
      this.loading = false
      this.title = '添加'
    }
  },
  mounted () {
    if (this.title === '添加') {
      this.$refs.editor.initEditor()
    }
    this.getBrandList()
    this.getBrandCategoryList()
    this.areaCode()
    this.getProducingAreaList()
  },
  beforeDestroy () {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
  methods: {
    getDetail (id) {
      this.$http.post('/cosmeticProduct/cosmeticProduct/detail', { id }).then(res => {
        if (res.data.code === '200') {
          this.form = res.data.data
          this.$refs.editor.initEditor(this.form.detail)
          this.form.newProducts = res.data.data.newProducts ? res.data.data.newProducts : '0'
          this.pictureList = this.form.picture ? this.form.picture.split(',') : []
          let list = this.form.videoUrl ? this.form.videoUrl.split(',') : []
          list.forEach(item => {
            this.videoList.push({name: item, url: item})
          })
          if (res.data.data.address && res.data.data.address.indexOf(',') > 0) {
            this.form.address = res.data.data.address.split(',')
          }
          if (res.data.data.wasForeign !== '0' && res.data.data.wasForeign !== '1') {
            this.form.wasForeign = '1'
          }
          let one = this.brands.filter(item => item.id === this.form.brandId)
          this.form.oneList = one[0].one ? one[0].one.split(',') : []
          this.selectCategoryList = []
          this.twoList = []
          this.brandCategoryList.forEach(item => {
            this.form.oneList.forEach(i => {
              if (i === item.id) {
                this.selectCategoryList.push({
                  name: item.name,
                  id: item.id
                })
                this.twoList.push({
                  name: item.name,
                  id: item.id,
                  data: item.children
                })
              }
            })
          })
        }
        this.loading = false
      }).catch(e => {
        console.log(e)
        this.loading = false
      })
    },
    async getBrandList () {
      let { data: res } = await this.$http.get('/cosmeticProduct/cosmeticProduct/getBrandList')
      if (res.code === '200') {
        this.brands = res.data
        if (this.id) {
          this.timer = setTimeout(() => {
            this.getDetail(this.id)
          }, 500)
        }
      }
    },
    getBrandCategoryList () {
      this.$http.get('/cosmeticBrand/cosmeticBrand/getBrandCategoryList').then(res => {
        if (res.data.code === '200') {
          this.brandCategoryList = res.data.data
        }
      })
    },
    getOneList (node) {
      let one = this.brands.filter(item => item.id === node)
      this.form.oneList = one[0].one ? one[0].one.split(',') : []
      this.selectCategoryList = []
      this.twoList = []
      this.form.category = ''
      this.brandCategoryList.forEach(item => {
        this.form.oneList.forEach(i => {
          if (i === item.id) {
            this.selectCategoryList.push({
              name: item.name,
              id: item.id
            })
            this.twoList.push({
              name: item.name,
              id: item.id,
              data: item.children
            })
          }
        })
      })
    },
    getPicture (list) {
      this.form.picture = list.join(',')
    },
    getVideo (list) {
      this.form.videoUrl = list.map(item => item.url).join(',')
    },
    getProducingAreaList () {
      this.$http
        .get('/brandArea/getBrandAreaList')
        .then((res) => {
          if (res.data.code === '200') {
            this.originOptions = res.data.data
          }
        })
    },
    areaCode () {
      this.$http
        .get('/areaCode/getList')
        .then((res) => {
          if (res.data.code === '200') {
            res.data.data.forEach(item => {
              if (item.id !== '5000') {
                this.areaCodeList.push(item)
              }
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    setHtml (html) {
      this.form.detail = html
    },
    back () {
      this.$router.push('/brandProduct')
    },
    changeRecord (val) {
      this.form.record = ''
    },
    save () {
      this.$refs.form.validate(val => {
        if (val) {
          let params = JSON.parse(JSON.stringify(this.form))
          params.one = this.form.oneList.join(',')
          if (typeof (this.form.address) !== 'string') {
            params.address = this.form.address ? this.form.address.join(',') : ''
          }
          delete params.oneList
          let url = ''
          if (this.type === 'add') {
            url = '/cosmeticProduct/cosmeticProduct/add'
          } else {
            url = '/cosmeticProduct/cosmeticProduct/update'
          }
          this.$http.post(url, params).then(res => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.$router.push('/brandProduct')
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(e => {
            console.log(e)
          })
        } else {
          if (!this.form.category) return this.$message.error('请选择二级品类')
          if (!this.form.name) return this.$message.error('请输入中文名')
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/productManagement/brandDetail.vue